import { render, staticRenderFns } from "./TemplateConfig.vue?vue&type=template&id=a36f92a8&scoped=true&"
import script from "./TemplateConfig.vue?vue&type=script&lang=js&"
export * from "./TemplateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36f92a8",
  null
  
)

export default component.exports